export const colors = {
  white: "#fff",
  black: "#000",
  blue1: "#004A93",
  blue2: "#3677C7",
  blue3: "#00BED4",
  lightGrey: "#eee",
  codGrey: "#181818",
  codGrey20: "rgba(13,13,13,20%)",
  white30: "rgba(255,255,255,30%)",
  white50: "rgba(255,255,255,50%)",
  white60: "rgba(255,255,255,60%)",
  black50: "rgba(0,0,0,50%)",
  silverChalice: "#a6a6a6",
  grey1: "#f6f5f7",
  grey2: "#eee",
  brown1: "#3F3D56",
};
